/* CP Produkt-Beschreibung — bereitet den Text aus dem Produktfeed auf:
   Tabellen bekommen Spaltenbeschriftungen fuers Handy, der Merkmale-Absatz wird in
   Kacheln zerlegt, der Zulassungsabschnitt in einen Hinweiskasten gesetzt.
   Dazu: erster Absatz als Anlauf, Absaetze mit fettem Satzanfang in den Hinweiskasten,
   "Begriff: Wert"-Zeilen als Datenzeilen, Telefonnummern als Anruf-Link.
   Ohne JS bleibt die Beschreibung unveraendert lesbar. */
(function () {
  var CHECK = 'M5 12.2 9.4 16.6 19 7';
  var PHONE = 'M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z';

  function svgPath(d) {
    var s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    s.setAttribute('viewBox', '0 0 24 24');
    s.setAttribute('aria-hidden', 'true');
    var p = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    p.setAttribute('d', d);
    s.appendChild(p);
    return s;
  }

  function svgCheck() { return svgPath(CHECK); }

  function addClass(el, name) {
    if ((' ' + el.className + ' ').indexOf(' ' + name + ' ') > -1) return;
    el.className = el.className ? el.className + ' ' + name : name;
  }

  function hasClass(el, name) {
    return (' ' + el.className + ' ').indexOf(' ' + name + ' ') > -1;
  }

  /* Direkte Kinder als feste Liste — die HTMLCollection selbst ist live */
  function kids(box) {
    var out = [], c = box.children;
    for (var i = 0; i < c.length; i++) out.push(c[i]);
    return out;
  }

  /* Spaltenbeschriftungen an die Zellen haengen (fuer die Kartenansicht mobil) */
  function labelTables(box) {
    var tables = box.querySelectorAll('table');
    for (var t = 0; t < tables.length; t++) {
      var heads = tables[t].querySelectorAll('thead th');
      if (!heads.length) continue;
      var names = [];
      for (var h = 0; h < heads.length; h++) names.push(heads[h].textContent.trim());
      var rows = tables[t].querySelectorAll('tbody tr');
      for (var r = 0; r < rows.length; r++) {
        var cells = rows[r].children;
        for (var c = 0; c < cells.length; c++) {
          if (names[c]) cells[c].setAttribute('data-l', names[c]);
        }
      }
    }
  }

  /* Tabelle in eine Karte fassen, mit Hinweiszeile darunter */
  function wrapTables(box, note) {
    var tables = box.querySelectorAll('table');
    for (var i = 0; i < tables.length; i++) {
      var tb = tables[i];
      if (tb.parentNode && tb.parentNode.classList &&
          tb.parentNode.classList.contains('cp-pi__tablewrap')) continue;
      var wrap = document.createElement('div');
      wrap.className = 'cp-pi__tablewrap';
      tb.parentNode.insertBefore(wrap, tb);
      wrap.appendChild(tb);
      if (note) {
        var n = document.createElement('div');
        n.className = 'cp-pi__tnote';
        var s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        s.setAttribute('viewBox', '0 0 24 24');
        s.setAttribute('aria-hidden', 'true');
        var c1 = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        c1.setAttribute('cx', '12'); c1.setAttribute('cy', '12'); c1.setAttribute('r', '9');
        var p1 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        p1.setAttribute('d', 'M12 11v5M12 8h.01');
        s.appendChild(c1); s.appendChild(p1);
        n.appendChild(s);
        n.appendChild(document.createTextNode(note));
        wrap.appendChild(n);
      }
    }
  }

  /* Alles zwischen einer Ueberschrift und der naechsten einsammeln */
  function sectionAfter(head) {
    var out = [], el = head.nextElementSibling;
    while (el && !/^H[2-4]$/.test(el.tagName)) {
      out.push(el);
      el = el.nextElementSibling;
    }
    return out;
  }

  function headingMatch(box, words) {
    var hs = box.querySelectorAll('h2, h3, h4');
    for (var i = 0; i < hs.length; i++) {
      var txt = hs[i].textContent.toLowerCase();
      for (var w = 0; w < words.length; w++) {
        if (txt.indexOf(words[w]) > -1) return hs[i];
      }
    }
    return null;
  }

  /* Darf an dieser Stelle getrennt werden? Nicht mitten in "mit/ohne",
     nicht innerhalb einer Klammer, nicht hinter Artikel oder Praeposition. */
  var STOP = (' der die das den dem des ein eine einer einem einen bei nach von vom ' +
              'ueber über fuer für je und oder in im zur zum auf mit ohne als wie pro ab ').split(' ');

  function canCut(text, at) {
    if (at <= 0) return false;
    var before = text.charAt(at - 1);
    if (before === '/' || before === '-') return false;
    var open = 0;
    for (var i = 0; i < at; i++) {
      var ch = text.charAt(i);
      if (ch === '(') open++;
      else if (ch === ')') open--;
    }
    if (open > 0) return false;
    var words = text.slice(0, at).trim().split(/\s+/);
    var last = (words[words.length - 1] || '').toLowerCase().replace(/[.,;:]+$/, '');
    return STOP.indexOf(last) < 0;
  }

  /* Merkmale: Fliesstext an bekannten Stellen in Einzelpunkte zerlegen */
  function splitFacts(box, marks) {
    if (!marks.length) return;
    var head = headingMatch(box, ['technische merkmale', 'merkmale', 'eigenschaften']);
    if (!head) return;
    var parts = sectionAfter(head);
    if (!parts.length) return;

    for (var i = 0; i < parts.length; i++) {
      var el = parts[i];
      if (el.tagName !== 'P') continue;
      var text = el.textContent.replace(/\s+/g, ' ').trim();
      if (!text || text.length < 25) continue;

      /* Schnittstellen sammeln, dann in einem Durchgang zerlegen */
      var cuts = [];
      for (var m = 0; m < marks.length; m++) {
        var mark = marks[m].trim();
        if (!mark) continue;
        var from = 0;
        while (true) {
          var at = text.indexOf(mark, from);
          if (at < 0) break;
          if (canCut(text, at) && cuts.indexOf(at) < 0) cuts.push(at);
          from = at + mark.length;
        }
      }
      if (!cuts.length) continue;
      cuts.sort(function (a, b) { return a - b; });

      var items = [], prev = 0;
      for (var c = 0; c < cuts.length; c++) {
        items.push(text.slice(prev, cuts[c]));
        prev = cuts[c];
      }
      items.push(text.slice(prev));
      items = items.map(function (x) { return x.trim(); })
                   .filter(function (x) { return x.length > 2; });
      if (items.length < 2) continue;

      var grid = document.createElement('div');
      grid.className = 'cp-pi__facts';
      for (var k = 0; k < items.length; k++) {
        var row = document.createElement('div');
        row.className = 'cp-pi__fact';
        row.appendChild(svgCheck());
        row.appendChild(document.createTextNode(items[k]));
        grid.appendChild(row);
      }
      el.parentNode.replaceChild(grid, el);
    }
  }

  /* Zulassungs- und Hinweisabschnitte in einen Kasten setzen */
  function boxNotes(box) {
    var head = headingMatch(box, ['zulassung', 'wichtiger hinweis', 'hinweis']);
    if (!head) return;
    var parts = sectionAfter(head);
    if (!parts.length) return;
    var kasten = document.createElement('div');
    kasten.className = 'cp-pi__legal';
    head.parentNode.insertBefore(kasten, parts[0]);
    for (var i = 0; i < parts.length; i++) kasten.appendChild(parts[i]);
  }

  /* Erster Absatz der Beschreibung bekommt etwas mehr Gewicht */
  function markLead(box) {
    var list = kids(box);
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      if (/^H[2-4]$/.test(el.tagName)) return;
      if (el.tagName !== 'P') continue;
      if (el.textContent.replace(/\s+/g, ' ').trim().length < 40) return;
      addClass(el, 'cp-pi__leadp');
      return;
    }
  }

  /* Kurze Absaetze, die mit einem fetten Satz anfangen, sind Hinweise */
  function boxStrongIntro(box) {
    var list = kids(box), made = 0;
    for (var i = 0; i < list.length && made < 2; i++) {
      var p = list[i];
      if (p.tagName !== 'P' || hasClass(p, 'cp-pi__leadp')) continue;
      var f = p.firstChild;
      while (f && f.nodeType === 3 && !f.nodeValue.replace(/\s+/g, '')) f = f.nextSibling;
      if (!f || f.nodeType !== 1 || f.tagName !== 'STRONG') continue;
      var t = p.textContent.replace(/\s+/g, ' ').trim();
      if (t.length < 20 || t.length > 260) continue;
      var kasten = document.createElement('div');
      kasten.className = 'cp-pi__legal';
      p.parentNode.insertBefore(kasten, p);
      kasten.appendChild(p);
      made++;
    }
  }

  /* "Nabendurchmesser je Lochkreis: 5x112: 66,6 mm, ..." wird zur Datenzeile */
  var DL = /^([^:]{3,44}):\s*(\S.*)$/;

  function dataRows(box) {
    var list = kids(box), group = null;
    for (var i = 0; i < list.length; i++) {
      var p = list[i];
      if (p.tagName !== 'P' || hasClass(p, 'cp-pi__leadp') || p.getElementsByTagName('strong').length) {
        group = null; continue;
      }
      var t = p.textContent.replace(/\s+/g, ' ').trim();
      var m = DL.exec(t);
      if (!m) { group = null; continue; }
      var key = m[1].trim(), val = m[2].trim();
      if (val.length < 2 || val.length > 120 || val.indexOf('. ') > -1 ||
          /[.!?]$/.test(key) || /[?!]/.test(key)) { group = null; continue; }
      if (!group) {
        group = document.createElement('div');
        group.className = 'cp-pi__dl';
        p.parentNode.insertBefore(group, p);
      }
      var row = document.createElement('div');
      row.className = 'cp-pi__dlrow';
      var ke = document.createElement('span');
      ke.className = 'cp-pi__dlk';
      ke.textContent = key;
      var ve = document.createElement('span');
      ve.className = 'cp-pi__dlv';
      ve.textContent = val.replace(/[.;]$/, '');
      row.appendChild(ke);
      row.appendChild(ve);
      group.appendChild(row);
      p.parentNode.removeChild(p);
    }
  }

  /* Telefonnummern im Fliesstext anklickbar machen */
  var TEL = /(?:\+49|0)[\d\s\/\-()]{7,20}\d/g;

  /* Alle Textknoten eines Absatzes, auch die in <strong> oder <em> */
  function textNodes(el, out) {
    var c = el.childNodes;
    for (var i = 0; i < c.length; i++) {
      if (c[i].nodeType === 3) out.push(c[i]);
      else if (c[i].nodeType === 1) textNodes(c[i], out);
    }
    return out;
  }

  function linkPhones(box) {
    var ps = box.querySelectorAll('p'), touched = [], i;
    for (i = 0; i < ps.length; i++) {
      var p = ps[i];
      if (p.getElementsByTagName('a').length) continue;
      var texts = textNodes(p, []);
      for (var n = 0; n < texts.length; n++) {
        var node = texts[n], s = node.nodeValue, m, last = 0, frag = null;
        TEL.lastIndex = 0;
        while ((m = TEL.exec(s))) {
          var raw = m[0], digits = raw.replace(/[^0-9]/g, '');
          if (digits.length < 9 || digits.length > 15) continue;
          if (!frag) frag = document.createDocumentFragment();
          frag.appendChild(document.createTextNode(s.slice(last, m.index)));
          var a = document.createElement('a');
          a.className = 'cp-pi__tel';
          a.setAttribute('href', 'tel:' + raw.replace(/[^0-9+]/g, ''));
          a.textContent = raw;
          frag.appendChild(a);
          last = m.index + raw.length;
        }
        if (frag) {
          frag.appendChild(document.createTextNode(s.slice(last)));
          node.parentNode.replaceChild(frag, node);
          if (touched.indexOf(p) < 0) touched.push(p);
        }
      }
    }
    /* Nur direkte Kinder bekommen das Symbol — sonst haette es keinen Bezugsrahmen */
    for (i = 0; i < touched.length; i++) {
      var el = touched[i];
      if (el.parentNode !== box || hasClass(el, 'cp-pi__contact')) continue;
      addClass(el, 'cp-pi__contact');
      el.insertBefore(svgPath(PHONE), el.firstChild);
    }
  }

  function init(box) {
    if (box.__cpPiReady) return;
    box.__cpPiReady = 1;
    var marks = (box.dataset.facts || '').split(',');
    var auto = ' ' + (box.dataset.auto === undefined ? 'lead note data tel' : box.dataset.auto) + ' ';
    function on(name) { return auto.indexOf(' ' + name + ' ') > -1; }

    if (on('lead')) { try { markLead(box); } catch (e) {} }
    try { splitFacts(box, marks); } catch (e) {}
    try { boxNotes(box); } catch (e) {}
    try { labelTables(box); } catch (e) {}
    try { wrapTables(box, (box.dataset.fitnote || '').trim()); } catch (e) {}
    if (on('note')) { try { boxStrongIntro(box); } catch (e) {} }
    if (on('data')) { try { dataRows(box); } catch (e) {} }
    if (on('tel')) { try { linkPhones(box); } catch (e) {} }
  }

  function scan(scope) {
    var list = (scope || document).querySelectorAll('[data-cp-pi-body]');
    for (var i = 0; i < list.length; i++) init(list[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
